import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'
import { BusinessHour } from '@/interface/api'
import { ReservationFormViewModel } from '@/models/ReservationFormViewModel'

export interface IClinic {
  medicalBusinessId: string
  name: string
  clinicId: string
  clinicalDepartmentId: string
  treatmentCourseId: string
  business_hours: BusinessHour[]
  holiday_flag: boolean
  businessDays: string[]
  nonTargetDays: {
    am: boolean
    pm: boolean
  }[]
}
export interface IChoice {
  reservationDate: Date | null
  isAm: boolean | null
}
export interface IForm {
  // クリニック
  clinic: IClinic
  // 診察種類
  treatmentCategoryName: string
  // 診察種類
  desiredTreatment: string
  // 予約内容
  isFirstTreatment: string
  // ご予約日
  reservationDate: Date
  // 第1候補日
  firstChoice: IChoice
  // 第2候補日
  secondChoice: IChoice
  // おなまえ
  firstName: string
  lastName: string
  // 生年月日
  birthYear: number
  birthMonth: number
  birthDate: number
  // 電話番号
  phoneNumber: string
  // メールアドレス
  email: string
  // 連絡方法
  contactTool: string
  // ご意見・ご質問
  comment: string
  // spotId
  treatmentSpotId: string
}

@Module({ dynamic: true, store, name: 'form' })
class Form extends VuexModule implements IForm {
  public clinic: IClinic = {
    medicalBusinessId: '',
    name: '',
    clinicId: '',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    business_hours: [],
    holiday_flag: false,
    businessDays: [],
    nonTargetDays: []
  }

  public treatmentCategoryName = 'face_to_face'
  public desiredTreatment = ''
  public isFirstTreatment = ''
  public reservationDate = new Date()
  public firstChoice: IChoice = {
    reservationDate: null,
    isAm: null
  }

  public secondChoice: IChoice = {
    reservationDate: null,
    isAm: null
  }

  public firstName = ''
  public lastName = ''
  public birthYear = 1980
  public birthMonth = 1
  public birthDate = 1
  public phoneNumber = ''
  public email = ''
  public contactTool = ''
  public comment = ''
  public treatmentSpotId = ''

  @Mutation
  private CLINIC(clinic: IClinic) {
    this.clinic = clinic
  }

  @Mutation
  private CLINIC_NAME(name: string) {
    this.clinic.name = name
  }

  @Mutation
  private CLINIC_ID(clinicId: string) {
    this.clinic.clinicId = clinicId
  }

  @Mutation
  private CLINICAL_DEPERTMENT_ID(clinicalDepartmentId: string) {
    this.clinic.clinicalDepartmentId = clinicalDepartmentId
  }

  @Mutation
  private TREATMENT_COURSE_ID(treatmentCourseId: string) {
    this.clinic.treatmentCourseId = treatmentCourseId
  }

  @Mutation
  private BUSINESS_HOURS(business_hours: BusinessHour[]) {
    this.clinic.business_hours = business_hours
  }

  @Mutation
  private HOLIDAY_FLAG(holiday_flag: boolean) {
    this.clinic.holiday_flag = holiday_flag
  }

  @Mutation
  private BUSINESS_DAYS(businessDays: string[]) {
    this.clinic.businessDays = businessDays
  }

  @Mutation
  private DESIRED_TREATMENT(desiredTreatment: string) {
    this.desiredTreatment = desiredTreatment
  }

  @Mutation
  private TREATMENT_CATEGORY_NAME(treatmentCategoryName: string) {
    this.treatmentCategoryName = treatmentCategoryName
  }

  @Mutation
  private IS_FIRST_TREATMENT(isFirstTreatment: string) {
    this.isFirstTreatment = isFirstTreatment
  }

  @Mutation
  private RESERVATION_DATE(reservationDate: Date) {
    this.reservationDate = reservationDate
  }

  @Mutation
  private FIRST_CHOICE(firstChoice: IChoice) {
    this.firstChoice = firstChoice
  }

  @Mutation
  private FIRST_CHOICE_RESERVATION_DATE(reservationDate: Date) {
    this.firstChoice.reservationDate = reservationDate
  }

  @Mutation
  private FIRST_CHOICE_IS_AM(isAm: boolean) {
    this.firstChoice.isAm = isAm
  }

  @Mutation
  private SECOND_CHOICE(secondChoice: IChoice) {
    this.secondChoice = secondChoice
  }

  @Mutation
  private SECOND_CHOICE_RESERVATION_DATE(reservationDate: Date) {
    this.secondChoice.reservationDate = reservationDate
  }

  @Mutation
  private SECOND_CHOICE_IS_AM(isAm: boolean) {
    this.secondChoice.isAm = isAm
  }

  @Mutation
  private FIRST_NAME(firstName: string) {
    this.firstName = firstName
  }

  @Mutation
  private LAST_NAME(lastName: string) {
    this.lastName = lastName
  }

  @Mutation
  private BIRTH_YEAR(birthYear: number) {
    this.birthYear = birthYear
  }

  @Mutation
  private BIRTH_MONTH(birthMonth: number) {
    this.birthMonth = birthMonth
  }

  @Mutation
  private BIRTH_DATE(birthDate: number) {
    this.birthDate = birthDate
  }

  @Mutation
  private PHONE_NUMBER(phoneNumber: string) {
    this.phoneNumber = phoneNumber
  }

  @Mutation
  private EMAIL(email: string) {
    this.email = email
  }

  @Mutation
  private CONTACT_TOOL(contactTool: string) {
    this.contactTool = contactTool
  }

  @Mutation
  private COMMENT(comment: string) {
    this.comment = comment
  }

  @Mutation
  private TREATMENT_SPOT_ID(treatmentSpotId: string) {
    this.treatmentSpotId = treatmentSpotId
  }

  @Action
  private setClinicName(name: string) {
    this.CLINIC_NAME(name)
  }

  @Action
  private setClinicId(clinicId: string) {
    this.CLINIC_ID(clinicId)
  }

  @Action
  private setClinicalDepartmentId(clinicalDepartmentId: string) {
    this.CLINICAL_DEPERTMENT_ID(clinicalDepartmentId)
  }

  @Action
  private setTreatmentCourseId(treatmentCourseId: string) {
    this.TREATMENT_COURSE_ID(treatmentCourseId)
  }

  @Action
  private setBusinessHours(business_hours: BusinessHour[]) {
    this.BUSINESS_HOURS(business_hours)
  }

  @Action
  private setHolidayFlag(holiday_flag: boolean) {
    this.HOLIDAY_FLAG(holiday_flag)
  }

  @Action
  private setBusinessDays(businessDays: string[]) {
    this.BUSINESS_DAYS(businessDays)
  }

  @Action
  private setTreatmentCategoryName(treatmentCategoryName: string) {
    this.TREATMENT_CATEGORY_NAME(treatmentCategoryName)
  }

  @Action
  private setIsFirstTreatment(isFirstTreatment: string) {
    this.IS_FIRST_TREATMENT(isFirstTreatment)
  }

  @Action
  private setReservationDate(reservationDate: Date) {
    this.RESERVATION_DATE(reservationDate)
  }

  @Action
  private setFirstChoiceReservationDate(reservationDate: Date) {
    this.FIRST_CHOICE_RESERVATION_DATE(reservationDate)
  }

  @Action
  private setFirstChoiceIsAm(isAm: boolean) {
    this.FIRST_CHOICE_IS_AM(isAm)
  }

  @Action
  private setSecondChoiceReservationDate(reservationDate: Date) {
    this.SECOND_CHOICE_RESERVATION_DATE(reservationDate)
  }

  @Action
  private setSecondChoiceIsAm(isAm: boolean) {
    this.SECOND_CHOICE_IS_AM(isAm)
  }

  @Action
  public setFirstName(firstName: string) {
    this.FIRST_NAME(firstName)
  }

  @Action
  public setLastName(lastName: string) {
    this.LAST_NAME(lastName)
  }

  @Action
  private setBirthYear(birthYear: number) {
    this.BIRTH_YEAR(birthYear)
  }

  @Action
  private setBirthMonth(birthMonth: number) {
    this.BIRTH_MONTH(birthMonth)
  }

  @Action
  private setBirthDate(birthDate: number) {
    this.BIRTH_DATE(birthDate)
  }

  @Action
  private setPhoneNumber(phoneNumber: string) {
    this.PHONE_NUMBER(phoneNumber)
  }

  @Action
  private setEmail(email: string) {
    this.EMAIL(email)
  }

  @Action
  private setContactTool(contactTool: string) {
    this.CONTACT_TOOL(contactTool)
  }

  @Action
  private setComment(comment: string) {
    this.COMMENT(comment)
  }

  @Action
  private setTreatmentSpotId(treatmentSpotId: string) {
    this.TREATMENT_SPOT_ID(treatmentSpotId)
  }

  @Action
  public setReservationForm(form: ReservationFormViewModel) {
    this.CLINIC(form.clinic)
    this.DESIRED_TREATMENT(form.desiredTreatment)
    this.TREATMENT_CATEGORY_NAME(form.treatmentCategoryName)
    this.IS_FIRST_TREATMENT(form.isFirstTreatment)
    this.RESERVATION_DATE(form.reservationDate)
    this.FIRST_CHOICE(form.firstChoice)
    this.SECOND_CHOICE(form.secondChoice)
    this.FIRST_NAME(form.firstName)
    this.LAST_NAME(form.lastName)
    this.BIRTH_YEAR(form.birthYear)
    this.BIRTH_MONTH(form.birthMonth)
    this.BIRTH_DATE(form.birthDate)
    this.PHONE_NUMBER(form.phoneNumber)
    this.EMAIL(form.email)
    this.CONTACT_TOOL(form.contactTool)
    this.COMMENT(form.comment)
    this.TREATMENT_SPOT_ID(form.treatmentSpotId)
  }
}
export const ReservationForm = getModule(Form)
